import React from "react"
import { createStyles, WithStyles, withStyles } from "@material-ui/styles"
import Heading from "./heading"
import TeamListItem, { TeamMember } from "./team-list-item"

const styles = createStyles({
  summary: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: 46,
    "@media (max-width: 479.95px)": {
      padding: 20,
    },
  },
  summaryHeader: {
    fontWeight: 400,
    fontSize: "1rem",
    lineHeight: "1.56rem",
    textAlign: "center",
    color: "#898989",
    maxWidth: 710,
  },
  title: {
    fontWeight: 800,
    fontSize: "2.33rem",
    lineHeight: "3.27rem",
    color: "#000000",
  },
  coloredTitle: {
    color: "#FF7900",
  },
  grid: {
    width: "100%",
    margin: "50px 0",
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(308px, 1fr))",
    gap: "40px",
    "@media (max-width: 479.95px)": {
      gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    },
  },
  gridItem: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItem: "center",
  },
})

export interface Props {
  title: string
  coloredWords: number
  description: string
  teamMembers: TeamMember[]
}

type PropsAndStyles = Props & WithStyles<typeof styles>

const TeamList = ({
  classes,
  title,
  coloredWords,
  description,
  teamMembers,
}: PropsAndStyles) => (
  <div className={classes.summary}>
    <Heading
      title={title}
      coloredWords={coloredWords}
      description={description}
    />

    <div className={classes.grid}>
      {teamMembers.map(member => (
        <div className={classes.gridItem}>
          <TeamListItem member={member} />
        </div>
      ))}
    </div>
  </div>
)

export default withStyles(styles)(TeamList)
